import { render, staticRenderFns } from "./ArtistData.vue?vue&type=template&id=f9380df4&"
import script from "./ArtistData.vue?vue&type=script&lang=js&"
export * from "./ArtistData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports